import React from 'react';
import { localize } from 'react-localize-redux';
import { OtherOccupantsFieldArray } from 'components/shared/OtherOccupantsFieldArray';

import { FieldArray } from 'redux-form';

class OtherOccupants extends React.Component {
  render() {
    return (
      <div className="row">
        <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
          {this.props.translate('landlordPortal.otherOccupants.otherOccupantDetails')}
        </h5>
        <FieldArray name="other_occupants" component={OtherOccupantsFieldArray} />
      </div>
    );
  }
}

export default localize()(OtherOccupants);
